module.exports = __webpack_public_path__ + "static/media/storyB_background.73520f6b.png";


//////////////////
// WEBPACK FOOTER
// ./src/storyB/static/storyB_background.png
// module id = 328
// module chunks = 0